// Main
const mainElement = document.getElementsByTagName('body')[0];

// DOM Elements for the reference filters
const referenceCardsElements = document.querySelectorAll(".reference-card");
const filterLayerElement = document.getElementById("referenceFilterLayer");
const closeButtonElement = document.getElementById(
  "referenceFilterCloseButton"
);
const layerButtonElement = document.getElementById(
  "referenceFilterLayerButton"
);
const referencesFilterCheckboxWrapperElement = document.getElementById(
  "referencesFilterCheckboxWrapper"
);
const referenceLayerResetButton = document.getElementById(
  "referencesFilterResetButton"
);
const referenceLayerApplyButton = document.getElementById(
  "referencesFilterApplyButton"
);
const removeButtonsWrapper = document.getElementById("removeButtons")
let referenceFilterCheckBoxElements;

// variables for the reference filters
const categoryMapping = {
  0: "Baugewerbe",
  1: "Dienstleistungen",
  2: "Einkaufs- und Verbundgruppen",
  3: "Elektronik",
  4: "Freizeit",
  5: "Gesundheitswesen",
  6: "Handel",
  7: "Hotellerie",
  8: "Küchentechnik",
  9: "Nahrungs- und Genussmittel",
  10: "Software"
};
const allReferenceCategories = {};
const activeReferenceCategories = new Set();

// Only execute scripts on page with reference cards.
if (referenceCardsElements.length >= 1) {
  initReferenceFilters();
}

function initReferenceFilters() {
  getAllReferenceCategoriesAndAmount();
  renderFilterCheckboxes();
  addReferenceFiltersEventListeners();
  addCheckboxEventHandler();
  addRemoveButtonsEventHandler();
}

function addReferenceFiltersEventListeners() {
  closeButtonElement.addEventListener("click", () => {
    filterLayerElement.classList.remove("references__filter--open");
    mainElement.classList.remove("references__filter--open");
  });

  layerButtonElement.addEventListener("click", () => {
    mainElement.classList.add("references__filter--open");
    filterLayerElement.classList.add("references__filter--open");
  });

  referenceLayerResetButton.addEventListener("click", () => {
    resetAllCheckboxes();
    mainElement.classList.remove("references__filter--open");
    filterLayerElement.classList.remove("references__filter--open");
  });

  referenceLayerApplyButton.addEventListener("click", () => {
    // reremder refernce cards so filter changes are applied
    renderActiveReferenceCardsByCategory();
    mainElement.classList.remove("references__filter--open");
    filterLayerElement.classList.remove("references__filter--open");
  });
}

function addCheckboxEventHandler() {
  referenceFilterCheckBoxElements.forEach((referenceFilterCheckboxElement) => {
    // Update active categories set on checkbox click
    referenceFilterCheckboxElement.addEventListener("click", () => {
      if (
        activeReferenceCategories.has(
          referenceFilterCheckboxElement.dataset.referenceFilterCategory
        )
      ) {
        activeReferenceCategories.delete(
          referenceFilterCheckboxElement.dataset.referenceFilterCategory
        );
      } else {
        activeReferenceCategories.add(
          referenceFilterCheckboxElement.dataset.referenceFilterCategory
        );
      }

      renderFilterCheckboxesState();
    });
  });
}
function addRemoveButtonsEventHandler() {
  const removeButtons = document.querySelectorAll(".remove-buttons button");

  removeButtons.forEach((thisButton) => {
    thisButton.addEventListener("click", () => {
      activeReferenceCategories.delete(thisButton.dataset.referenceFilterCategory)
      renderActiveReferenceCardsByCategory();
      renderFilterCheckboxesState();
      renderRemoveButtons();
    })
  })
}

function resetAllCheckboxes() {
  activeReferenceCategories.clear();
  renderFilterCheckboxesState();
}

function renderActiveReferenceCardsByCategory() {
  referenceCardsElements.forEach((referenceCard) => {
    // only hide cards if at least one category is selected
    if (activeReferenceCategories.size >= 1) {
      referenceCard.classList.add("hidden");

      // check if amy category of current card is currently set to active
      if (
        referenceCard.dataset.referenceCategory
          .split(",")
          .some((category) => activeReferenceCategories.has(category))
      ) {
        referenceCard.classList.remove("hidden");
      }
    } else {
      referenceCard.classList.remove("hidden");
    }
  });
}

function renderFilterCheckboxesState() {
  referenceFilterCheckBoxElements.forEach((referenceFilterCheckboxElement) => {
    // Update active categories set on checkbox click
    referenceFilterCheckboxElement.checked = false;

    if (
      activeReferenceCategories.has(
        referenceFilterCheckboxElement.dataset.referenceFilterCategory
      )
    ) {
      referenceFilterCheckboxElement.checked = true;
    }
  });

  renderRemoveButtons();
}

function renderFilterCheckboxes() {
  let referencesFilterCheckboxWrapperContent = "";

  // construct checkboxes for all categories found on reference cards
  Object.keys(allReferenceCategories).forEach((category) => {
    referencesFilterCheckboxWrapperContent += createCheckboxHtml(category);
  });

  referencesFilterCheckboxWrapperElement.innerHTML =
    referencesFilterCheckboxWrapperContent;

  // Update checkboxElements variable so event handlers can be applied
  referenceFilterCheckBoxElements = document.querySelectorAll(
    "#referencesFilterCheckboxWrapper .form-check-input"
  );

  renderRemoveButtons();
}

function renderRemoveButtons() {
  let removeButtonsWrapperContent = "";

  Object.keys(allReferenceCategories).forEach((category) => {
    if (activeReferenceCategories.has(category)) {
      removeButtonsWrapperContent += createRemoveButtonHTML(category);
    }
  });

  removeButtonsWrapper.innerHTML = removeButtonsWrapperContent
  addRemoveButtonsEventHandler();
}

function getAllReferenceCategoriesAndAmount() {
  referenceCardsElements.forEach((referenceCard) => {
    const referenceCardCategories =
      referenceCard.dataset.referenceCategory.split(",");

    // go over all found categories for each card and track how often each category was present
    referenceCardCategories.forEach((category) => {
      allReferenceCategories[category] === undefined
        ? (allReferenceCategories[category] = 1)
        : allReferenceCategories[category]++;
    });
  });
}

function createCheckboxHtml(category) {
  return `
    <div class="form-check">
    <input
        class="form-check-input"
        id="referenceFilter${categoryMapping[category]}"
        name="referenceFilter${categoryMapping[category]}"
        type="checkbox"
        value=""
        data-testid="checkboxWithLabel"
        data-t-id="checkboxWithLabel"
        data-reference-filter-category="${category}"
    />
    <label class="form-check-label" for="referenceFilter${categoryMapping[category]}">${categoryMapping[category]} (${allReferenceCategories[category]})</label>
    </div>
    `;
}

function createRemoveButtonHTML (category) {
  return `
    <button data-reference-filter-category="${category}">${categoryMapping[category]} (${allReferenceCategories[category]})
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3 3L17 17" stroke="#141414" stroke-width="1.5"></path>
        <path d="M17 3L3 17" stroke="#141414" stroke-width="1.5"></path>
      </svg>
    </button>
  `
}
